
<!--
CONSULTA VAREJO PENDENCIAS CLIENTE DETALHES
-->

<template>
  <div class="container-full-width default-container p-3">

    <div class="row mb-2">
      <div class="col-10 lbl-title">
        CLIENTE: {{ detalhe.nome }}
      </div>
      <div class="col-2 text-right">
        <v-button label="Voltar" :success="false" @click="handleClose"></v-button>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" v-if="!detalhe || !detalhe.detalhes || detalhe.detalhes.length == 0">
        Nenhum movimento encontrado
      </div>
    </div>
    <div class="row mb-2" v-if="detalhe || detalhe.detalhes || detalhe.detalhes.length != 0">
      <div class="col-2 lbl-title">
        <div class="d-flex flex-column">
          <span class="mr-2">Valor do Pagamento</span>
          <div>
            <div class="d-flex justify-content-start align-items-start" style="gap:30px">
              <input-value ref="valorpagamento" class="vd-input " style="" :precision="2" v-model="valorPagamento" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <v-button class="bottom-center" label="Salvar" :success="true" @click="handleEnterPaymentValue">
        </v-button>
      </div>

    </div>

    <div class="default-container position-relative">
      <alert v-if="detalhe.detalhes.length == 0" type="norecord"></alert>
      <div class="mainbox" v-for="(item, index) in detalhe.detalhes" v-bind:key="index">
        <div class="box d-flex flex-wrap">
          <div class="col-3">
            <v-label v-if="index == 0" class="w-100" label="Data"></v-label>
            <span class="data-list">{{ item.data | formatDataHora }}</span>
          </div>
          <div class="col-3">
            <v-label v-if="index == 0" class="w-100" label="Nr.Documento"></v-label>
            <span class="data-list">{{ item.doc }} </span>
          </div>
          <div class="col-3">
            <v-label v-if="index == 0" class="w-100" label="Vencimento"></v-label>
            <span class="data-list">{{ item.dtv | formatDataHora }}</span>
          </div>
          <div class="col-3 text-right">
            <v-label v-if="index == 0" class="w-100" label="Valor"></v-label>
            <span class="data-list">R$ {{ item.vlr | formatValue(2) }}</span>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";

export default {
  props: {
    codvabertura: null,
    detalhe: {}
  },

  components: {
    Filtro,
    Chart,
  },

  data() {
    return {
      valorPagamento: null,

      colunas: [
      ],

      mounting: false,

    };
  },

  watch: {},

  methods: {
    async handleEnterPaymentValue() {
      const url = "varejo/recebimento_pendencia_cliente";

      const obj = {
        pendcli: {
          codvabertura: this.codvabertura,
          valor: this.valorPagamento,
          fin: this.detalhe.detalhes
        }
      }



      const data = await apiORDSpost(this.$store, url, obj, "post")
      if (data) {
        this.handleClose();
      }
    },

    handleClose() {
      this.$emit("closeform");
    },


    handleAction(act, obj) {
      //if (act == 21) {
      //  this.handleEdit(obj.codpedv)
      //}
    },


    handleBarGrid(item) {
      let options = { barDefault: true, btnView: false, btnEdit: false, }

      return options
    },

    getActions(pedv) {
      let actions = []

      // actions.push({ action: 21, label: 'Visualização' })
      return actions
    },


    async loadData(excel) {


    },

  },

  computed: {
  },

  mounted() {

  },

  created() {
  },
}


</script>

<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
  background: #c1c4c7;
  border: none;
}

table .var {
  min-width: 85px;
  text-align: center;
  background: #c1c4c7;
  display: inline-block;
}

table .var-negative {
  color: white;
  background: indianred;
}

table .var-positive {
  color: white;
  background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}

.bottom-center {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/consultas/consulta-varejo-pendcli-det.vue